import React, { useState, useEffect } from "react";
import { Select, Form, Menu, Dropdown, Input, Row, Col } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useSearchParams } from "react-router-dom";
import { message } from "antd";
import API from "../../../services/api-request";
import state from "../../../../src/config/valtio/store";

function FilterMenu(props) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [dataCard, setDataCard] = useState([]);

  const [filterForm] = Form.useForm();
  const [selectedCardId, setSelectedCardId] = useState(
    searchParams.get("id") ?? ""
  );
  const [selectedMsisdn, setSelectedMsisdn] = useState();

  const handleMenuClick = (e) => {
    const selectedItem = dataCard.find((item) => item.key === e);
    setSelectedCardId(selectedItem.key);
    setSelectedMsisdn(selectedItem.label);

    setSearchParams({
      ...Object.fromEntries(searchParams.entries()),
      id: selectedItem.key,
    });

    onQuerySet({ id: selectedItem.key });
  };

  const getDataCard = async () => {
    state.LOADING = true;

    await API.Get(`card`)
      .then((result) => {
        let dataTemp = [];
        result.data.forEach((data) => {
          dataTemp.push({ key: data.id.toString(), label: data.msisdn });
        });

        if (selectedCardId) {
          const selectedDefaultItem = dataTemp.find(
            (item) => item.key === selectedCardId
          );
          setSelectedMsisdn(selectedDefaultItem.label);
        }

        setDataCard(dataTemp);
      })
      .catch((err) => {
        setDataCard([]);
        message.info("Failed Fetch Cards Data!");
      });

    state.LOADING = false;
  };

  const onQuerySet = (values) => {
    props.onHandleQuery(values);
  };

  useEffect(() => {
    getDataCard();
    // eslint-disable-next-line
  }, []);

  const menu = () => {
    return (
      <Menu selectable onClick={handleMenuClick}>
        {dataCard.map((item) => (
          <Menu.Item key={item.key}>{item.label}</Menu.Item>
        ))}
      </Menu>
    );
  };

  return (
    <Form
      form={filterForm}
      layout="vertical"
      onFinishFailed={() => console.log("Error")}
    >
      <h2>Detail Card</h2>
      <hr />
      <Row gutter={[8, 8]} align="middle" style={{ marginTop: 16 }}>
        <Col xs={24} md={5} lg={3}>
          Filter by MSISDN :
        </Col>
        <Col xs={24} md={7} lg={5}>
          <Select
            value={selectedMsisdn}
            onChange={handleMenuClick}
            placeholder="Select MSISDN"
            showSearch
            optionFilterProp="label"
            options={dataCard.map((item) => ({
              value: item.key,
              label: item.label,
            }))}
            allowClear={false}
            style={{ width: "100%" }}
          />
        </Col>
        {/* <Col xs={24} md={7} lg={5}>
          <Dropdown overlay={menu("status")} trigger={["click"]}>
            <Input
              readOnly
              value={selectedMsisdn}
              suffix={<DownOutlined style={{ color: "rgba(0, 0, 0, 0.25)" }} />}
              placeholder="Select MSISDN"
              style={{ cursor: "pointer" }}
            />
          </Dropdown>
        </Col> */}
      </Row>
    </Form>
  );
}

export default FilterMenu;
